<template>
	<div :class="['price-table--feature', type]">
		<div class="price-table--feature-text" v-b-tooltip.html :title="tooltip">
			<Icon v-if="tooltip" icon="info" class="mr-1 correct-icon-top-1px"/>
			{{ text }}
			<span v-if="subText">{{ subText }}</span>
		</div>
		<div
			v-if="withFree"
			:class="['price-table--feature-content', isColoredBackground ? 'bg-color-purple-light' : 'bg-color-white']"
		>
			<template v-if="isTypeIcon">
				<Icon v-if="freeChecked" icon="checkmark"/>
			</template>
			<div v-else-if="isTypeContent" class="color-purple">-</div>
			<template v-else-if="isTypePrice">
				<Free/>
			</template>
		</div>
		<div
			v-for="product in products"
			:key="product.id"
			:class="['price-table--feature-content', isColoredBackground ? getProductBackgroundClass(product) : 'bg-color-white']"
		>
			<template v-if="isTypeIcon">
				<Icon
					v-if="isIconChecked(product)"
					icon="checkmark"
				/>
			</template>
			<div
				v-else-if="isTypeContent && contentProvider"
				:class="'color-' + getProductColor(product)"
			>
				{{ contentProvider(product) }}
			</div>
			<div v-else-if="isTypePrice" class="price-table--feature-content-price">
				<BuyButton
					:product="product"
					:upgradable-items="upgradableItems"
					:chosen-product="chosenProduct"
					:custom-button-click-handler="customButtonClickHandler"
					@buy="$emit('buy', $event)"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon.vue";
import {PRODUCT_COLORS, PRODUCT_COLORS_LIGHT} from "@/helper/product/Product";
import {mapGetters, mapState} from "vuex";
import Button from "@/vue/common/Button.vue";
import BuyButton from "@/vue/payment/price-table/BuyButton.vue";
import Free from "@/vue/payment/price-table/Free.vue";

const TYPE__ICON = 'icon';
const TYPE__CONTENT = 'content';
const TYPE__PRICE = 'price';

export default {
	components: {Free, BuyButton, Button, Icon},

	props: {
		withFree: {
			type: Boolean,
			required: false,
			default: true,
		},
		type: {
			type: String,
			required: false,
			default: TYPE__ICON,
		},
		text: {
			type: String,
			required: true,
		},
		subText: {
			type: String,
			required: false,
		},
		products: {
			type: Array,
			required: true,
		},
		freeChecked: {
			type: Boolean,
			required: false,
			default: false,
		},
		iconCheck: {
			type: Function,
			required: false,
		},
		contentProvider: {
			type: Function,
			required: false
		},
		customButtonClickHandler: {
			type: Boolean,
			required: false,
			default: false,
		},
		chosenProduct: {
			type: Object,
			required: false
		},
		upgradableItems: {
			type: Array,
			required: false
		},
		tooltip: {
			type: String,
			required: false
		}
	},

	computed: {
		...mapState('auth', {
			'authLoaded': 'loaded',
			'customer': 'customer'
		}),
		...mapGetters('auth', ['isLoggedIn']),
		isColoredBackground ()
		{
			return this.isTypePrice;
		},
		isTypeIcon ()
		{
			return this.type === TYPE__ICON;
		},
		isTypeContent ()
		{
			return this.type === TYPE__CONTENT;
		},
		isTypePrice ()
		{
			return this.type === TYPE__PRICE;
		},
	},

	methods: {
		isIconChecked (product)
		{
			if (!this.iconCheck)
			{
				return true;
			}

			return this.iconCheck(product);
		},
		getProductColor (product)
		{
			return PRODUCT_COLORS[product.id];
		},
		getProductBackgroundClass (product)
		{
			return 'bg-color-' + PRODUCT_COLORS_LIGHT[product.id];
		},
	}
}
</script>
